// @ts-nocheck
export const appColors = {
  blue10: '#e9f2ff',
  blue20: '#cce0ff',
  blue30: '#85b8ff',
  blue40: '#579dff',
  blue50: '#388bff',
  blue60: '#1d7afc',
  blue70: '#0c66e4',
  blue80: '#0055CC',
  blue90: '#09326C',
  blue100: '#1C2B41',

  neutral0: '#ffffff',
  neutral10: '#f7f8f9',
  neutral20: '#f1f2f4',
  neutral30: '#dcdfe4',
  neutral40: '#b3b9c4',
  neutral50: '#8590a2',
  neutral60: '#758195',
  neutral70: '#626f86',
  neutral80: '#44546f',
  neutral90: '#2c3e5d',
  neutral100: '#172b4d',
  neutral110: '#091e42',

  red10: '#ffeceb',
  red20: '#ffd5d2',
  red30: '#fd9891',
  red40: '#f87168',
  red50: '#f15b50',
  red60: '#e2483d',
  red70: '#c9372c',
  red80: '#ae2e24',
  red90: '#5d1f1a',
  red100: '#42221f',

  green10: '#dcfff1',
  green20: '#baf3db',
  green30: '#7ee2b8',
  green40: '#4bce97',
  green50: '#2abb7f',
  green60: '#22a06b',
  green70: '#1f845a',
  green80: '#216e4e',
  green90: '#164b35',
  green100: '#1c3329',

  orange10: '#fff3eb',
  orange20: '#fedec8',
  orange30: '#fec195',
  orange40: '#fea362',
  orange50: '#f38a3f',
  orange60: '#e56910',
  orange70: '#c25100',
  orange80: '#a54800',
  orange90: '#702e00',
  orange100: '#38291e',

  yellow10: '#fff7d6',
  yellow20: '#f8e6a0',
  yellow30: '#f5cd47',
  yellow40: '#e2b203',
  yellow50: '#cf9f02',
  yellow60: '#b38600',
  yellow70: '#946f00',
  yellow80: '#7f5f01',
  yellow90: '#533f04',
  yellow100: '#332e1b',
}
